var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.97727C3 6.05612 4.55704 4.5 6.47727 4.5H9.51954C9.93377 4.5 10.2695 4.83579 10.2695 5.25C10.2695 5.66421 9.93377 6 9.51954 6H6.47727C5.38523 6 4.5 6.88479 4.5 7.97727V17.5227C4.5 18.6151 5.38523 19.5 6.47727 19.5H16.0227C17.1147 19.5 18 18.6151 18 17.5227V14.4818C18 14.0676 18.3358 13.7318 18.75 13.7318C19.1642 13.7318 19.5 14.0676 19.5 14.4818V17.5227C19.5 19.4439 17.943 21 16.0227 21H6.47727C4.55704 21 3 19.4439 3 17.5227V7.97727Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 3.75C13.5 3.33579 13.8358 3 14.25 3H20.25C20.6642 3 21 3.33579 21 3.75V9.75C21 10.1642 20.6642 10.5 20.25 10.5C19.8358 10.5 19.5 10.1642 19.5 9.75V4.5H14.25C13.8358 4.5 13.5 4.16421 13.5 3.75Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2337 3.79084C20.5262 4.08421 20.5254 4.55908 20.232 4.85151L13.2795 11.7815C12.9861 12.0739 12.5112 12.0732 12.2188 11.7798C11.9264 11.4864 11.9272 11.0115 12.2205 10.7191L19.173 3.78912C19.4664 3.49671 19.9413 3.49747 20.2337 3.79084Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab1);
export default __webpack_public_path__ + "static/media/new-tab 1.ca22fcb430cc148af9a140ed13ce91ae.svg";
export { ForwardRef as ReactComponent };